export default "__VITE_ASSET__36b042a4__"